export default `return min(.65-length(fract(p+.5)-.5),p.y+.2);
  }`